import React from "react";
import "../PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <header className="policy-header">
        <h1>Política de Privacidade</h1>
        <p>
          Sua privacidade é importante para nós. Este documento descreve como
          coletamos, utilizamos e protegemos seus dados pessoais.
        </p>
      </header>

      <section className="policy-section">
        <h2>1. Dados Coletados</h2>
        <p>
          Coletamos e armazenamos apenas as informações fornecidas diretamente por você, como:
        </p>
        <ul>
          <li>
            <strong>Nome:</strong> Utilizado para identificação e personalização do acesso.
          </li>
          <li>
            <strong>E-mail:</strong> Utilizado como login para acessar a plataforma e para envio de comunicações.
          </li>
          <li>
            <strong>Matrícula:</strong> Utilizada para vincular sua conta e validar o acesso.
          </li>
        </ul>
        <p>
          Além disso, podemos coletar **logs de acesso** (como endereços IP e horários de login) exclusivamente para fins de auditoria e segurança da plataforma.
        </p>
      </section>

      <section className="policy-section">
        <h2>2. Uso dos Dados</h2>
        <p>
          As informações coletadas são utilizadas exclusivamente para:
        </p>
        <ul>
          <li>Gerenciamento e autenticação de contas de usuários.</li>
          <li>Envio de comunicações necessárias, como e-mails de confirmação ou suporte.</li>
          <li>Garantia de segurança e auditoria do sistema.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>3. Compartilhamento de Dados</h2>
        <p>
          Não compartilhamos seus dados com terceiros, exceto quando necessário para cumprir obrigações legais ou utilizar serviços essenciais à operação da plataforma.
        </p>
        <p>
          Isso inclui provedores de envio de e-mails, como **SendGrid**, e serviços de armazenamento em banco de dados seguro. Nenhum dado será vendido ou compartilhado para fins publicitários.
        </p>
      </section>

      <section className="policy-section">
        <h2>4. Base Legal</h2>
        <p>
          O processamento de seus dados é baseado no consentimento fornecido ao criar sua conta e no cumprimento de obrigações contratuais relacionadas ao uso da plataforma.
        </p>
      </section>

      <section className="policy-section">
        <h2>5. Direitos do Usuário</h2>
        <p>Você tem os seguintes direitos em relação aos seus dados pessoais:</p>
        <ul>
          <li>Acessar suas informações armazenadas.</li>
          <li>Solicitar a correção de informações incorretas ou incompletas.</li>
          <li>Solicitar a exclusão de sua conta e dos dados associados.</li>
          <li>Revogar o consentimento para o uso dos dados.</li>
        </ul>
        <p>
          Para exercer seus direitos, entre em contato conosco pelo e-mail abaixo.
        </p>
      </section>

      <section className="policy-section">
        <h2>6. Retenção e Exclusão de Dados</h2>
        <p>
          Ao solicitar a exclusão de sua conta, os dados serão removidos permanentemente em até **30 dias**. No entanto, alguns registros podem ser mantidos por tempo adicional para cumprimento de obrigações legais, auditoria ou segurança do sistema.
        </p>
      </section>

      <section className="policy-section">
        <h2>7. Atualizações da Política de Privacidade</h2>
        <p>
          Esta política pode ser atualizada periodicamente para refletir mudanças em nossas práticas ou requisitos legais.
        </p>
        <p>
          Em caso de alterações significativas, notificaremos os usuários por e-mail ou diretamente na plataforma.
        </p>
      </section>

      <section className="policy-section">
        <h2>8. Proteção de Dados</h2>
        <p>
          Implementamos medidas técnicas e organizacionais para proteger seus dados contra acessos não autorizados, perda ou alteração.
        </p>
      </section>

      <section className="policy-section">
        <h2>9. Contato</h2>
        <p>
          Para dúvidas ou solicitações relacionadas aos seus dados pessoais, entre em contato conosco pelo e-mail:  
          <strong> suporte@codefort.com</strong>.
        </p>
      </section>

      <footer className="policy-footer">
        <p>
          © {new Date().getFullYear()} CodeFort <br />
          Todos os direitos reservados
        </p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
